<template>
  <div v-if="profileLoaded">
    <nav class="navbar fixed">
      <div class="navbar-brand">
        <div class="hamburger-container">
          <span
            class="hamburger text-muted mr-sm mq-tablet-or-lower"
            @click="openDrawer"
          >
            <span class="fa-solid fa-bars"></span>
          </span>
          <img
            src="/static/assets/branding-2022/img/sharedo-logo-horiz-129.png"
          />
        </div>
        <current-document class="current-document"></current-document>
      </div>

      <div className="navbar-group right"></div>
    </nav>
    <nav v-bind:class="drawerClasses">
      <div class="drawer-overlay" @click="closeDrawer"></div>
      <div class="drawer-content">
        <div class="drawer-nav">
          <ul>
            <nav-item title="Menu" />
            <nav-item
              icon="fa-home"
              title="Home"
              to="/"
              @beforeNav="closeDrawer"
            />
            <nav-item title="Template Tools" />
            <nav-item
              v-if="connected && loggedIn && isDocumentAdmin"
              icon="fa-file-contract"
              :title="
                currentTemplates && currentTemplates.length > 0
                  ? 'Template Details'
                  : 'Link Template'
              "
              to="/templates"
              @beforeNav="closeDrawer"
            />
            <nav-item
              v-if="
                connected &&
                loggedIn &&
                isDocumentAdmin &&
                capabilities.separateContentBlocks
              "
              icon="fa-file-code"
              title="Content Blocks"
              :to="contentBlocksRoute"
              @beforeNav="closeDrawer"
            />
            <nav-item
              v-if="connected && loggedIn"
              icon="fa-file-invoice"
              title="Document Browser"
              to="/document-browser"
              @beforeNav="closeDrawer"
            />
            <nav-item
              v-if="
                connected &&
                loggedIn &&
                isDocumentAdmin &&
                currentTemplates &&
                currentTemplates.length > 0
              "
              icon="fa-tags"
              title="Tag Browser"
              to="/tags"
              @beforeNav="closeDrawer"
            />
            <nav-item
              v-if="
                connected &&
                loggedIn &&
                isDocumentAdmin &&
                currentTemplates &&
                currentTemplates.length > 0
              "
              icon="fa-code-branch"
              title="Display Rules"
              to="/businessrules"
              @beforeNav="closeDrawer"
            />
            <nav-item
              v-if="
                connected &&
                loggedIn &&
                isDocumentAdmin &&
                currentTemplates &&
                currentTemplates.length > 0
              "
              icon="fa-puzzle-piece"
              title="Sections"
              to="/sections"
              @beforeNav="closeDrawer"
            />
            <nav-item title="Document Tools" />
            <nav-item
              v-if="
                connected &&
                loggedIn &&
                canManageContentBlocks &&
                capabilities.separateContentBlocks
              "
              icon="fa-file-code"
              title="Clauses"
              :to="clausesRoute"
              @beforeNav="closeDrawer"
            />
            <nav-item
              v-if="
                connected &&
                loggedIn &&
                canManageContentBlocks &&
                !capabilities.separateContentBlocks
              "
              icon="fa-file-code"
              title="Content Blocks"
              to="/contentblocks"
              @beforeNav="closeDrawer"
            />
            <nav-item
              v-if="
                connected &&
                loggedIn &&
                capabilities.relatedContent &&
                !!sharedoId
              "
              icon="fa-paperclip"
              title="Related Content"
              to="/related-content"
              @beforeNav="closeDrawer"
            />
            <nav-item
              v-if="connected && loggedIn && !!sharedoId"
              icon="fa-check-circle"
              title="Finalise Document"
              to="/finalize-document"
              @beforeNav="closeDrawer"
            />
            <nav-item title="Other" />
            <nav-item
              v-if="connected && loggedIn && expertMode"
              icon="fa-flask"
              title="Advanced"
              to="/advanced"
              @beforeNav="closeDrawer"
            />
            <nav-item
              v-if="connected"
              icon="fa-wrench"
              title="Settings"
              to="/settings"
              @beforeNav="closeDrawer"
            />
            <nav-item
              v-if="connected && loggedIn"
              icon="fa-sign-out-alt"
              title="Log Out"
              to="/logout"
              @beforeNav="closeDrawer"
            />
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import { mapState } from "vuex";
import profile from "@/mixins/profile";
import currentTempates from "@/mixins/currentTemplates";
import NavItem from "./NavItem.vue";
import CurrentDocument from "@/components/document/CurrentDocument.vue";
import customProperties from "@/services/word/customPropertiesService";
import {
  ADMIN_DOCUMENT_ASSEMBLY,
  CONTENT_BLOCKS_READ,
} from "@/constants/permissions";
import {
  FOR_DOCUMENT_AUTHORS,
  FOR_TEMPLATE_AUTHORS,
} from "@/constants/contentBlockIncludes";

export default {
  components: { NavItem, CurrentDocument },
  mixins: [profile, currentTempates],
  data() {
    return {
      open: false,
      sharedoId: "",
      forceRenderKey: false,
    };
  },
  computed: {
    drawerClasses() {
      if (this.open) {
        return "drawer open";
      }
      return "drawer";
    },
    ...mapState({
      loggedIn: (state) => state.loggedIn,
      connected: (state) => state.connected,
    }),
    isDocumentAdmin: function () {
      return this.hasPermission(ADMIN_DOCUMENT_ASSEMBLY);
    },
    canManageContentBlocks: function () {
      if (this.capabilities.contentBlockPermissionsV2) {
        return (
          this.hasPermission(CONTENT_BLOCKS_READ) ||
          this.hasPermission(ADMIN_DOCUMENT_ASSEMBLY)
        );
      }

      return this.hasPermission(CONTENT_BLOCKS_READ);
    },
    clausesRoute: function () {
      return {
        name: "ContentBlocks",
        params: { include: FOR_DOCUMENT_AUTHORS },
      };
    },
    contentBlocksRoute: function () {
      return {
        name: "ContentBlocks",
        params: { include: FOR_TEMPLATE_AUTHORS },
      };
    },
  },
  methods: {
    openDrawer: function () {
      this.open = true;
    },
    closeDrawer: function () {
      this.open = false;
    },
  },
  watch: {
    loggedIn: function () {},
  },
  created: async function () {
    this.sharedoId = await customProperties.get("SharedoActivityId");
  },
};
</script>
<style lang="scss" scoped>
.hamburger-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  & > .hamburger {
    margin-top: 5px;
    cursor: pointer;
  }
}
.current-document {
  margin-top: 3px;
}
</style>